import {createHash} from 'crypto';
import JS from 'crypto-js';

export default {
  stringToBytes( str ) {  
    var ch, st, re = []; 
    for (var i = 0; i < str.length; i++ ) { 
      ch = str.charCodeAt(i);  // get char  
      st = [];                 // set up "stack"  
      do {  
        st.push( ch & 0xFF );  // push byte to stack  
        ch = ch >> 8;          // shift value down by 1 byte  
      }    
      while ( ch );  
      // add stack contents to result  
      // done because chars have "wrong" endianness  
      re = re.concat( st.reverse() ); 
    }  
    // return an array of bytes  
    return re;  
  },
  encrypt(algorithm, content) {
    let hash = createHash(algorithm)
    hash.update(content)
    return hash.digest('hex')
  },
  md5(str) {
    return this.encrypt('md5', str)
  },
  sha1(str) {
    return this.encrypt('sha1', str)
  },
  base64encode(str) {
      // first we use encodeURIComponent to get percent-encoded UTF-8,
      // then we convert the percent encodings into raw bytes which
      // can be fed into btoa.
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
          function toSolidBytes(match, p1) {
              return String.fromCharCode('0x' + p1);
          }));
  },
  base64decode(str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(atob(str).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
  },
  // 腾讯云 签名
  getsign(obj) {
    let str = Object.values(obj).sort().join('')
    return this.sha1(str)
  },

  toBase64TypeMD5(str) {
    return JS.MD5(str).toString(JS.enc.Base64)
  },
};